__turbopack_context__.v({
  "slider": "PlasmicCreditSlider-module__FbqanW__slider",
  "sliderThumb": "PlasmicCreditSlider-module__FbqanW__sliderThumb",
  "text": "PlasmicCreditSlider-module__FbqanW__text",
});
